import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { Typography as e } from "../Typography/Typography.js";
import "js-cookie";
import "react";
import { useMediaQuery as p } from "../../hooks/useMediaQuery.js";
import c from "clsx";
import '../../_assets/InfoItemBtn.By79bW7X.css';const d = "_item_a26ep_44", _ = "_btn_a26ep_51", o = {
  item: d,
  btn: _,
  "slide-in-out": "_slide-in-out_a26ep_1",
  "fade-in-out": "_fade-in-out_a26ep_1"
}, v = ({
  label: n,
  buttonText: i,
  className: r,
  onClick: m,
  ...s
}) => {
  const a = p("s");
  return /* @__PURE__ */ l("div", { className: c(o.item, r), children: [
    /* @__PURE__ */ t(e, { variant: "portalText", size: "1", color: "grey-1-new", children: n }),
    /* @__PURE__ */ t(
      e,
      {
        variant: "buttonUnderline",
        type: "button",
        size: a ? "medium" : "small",
        color: "brand-green-new",
        component: "button",
        onClick: m,
        className: o.btn,
        ...s,
        children: i
      }
    )
  ] });
};
export {
  v as InfoItemBtn
};
